import { MemberRole } from '@/core/constants/roles';
import { useActiveOrganization } from './useActiveOrganization';

/** `true` when the active organization's role for the current user is `owner` or `admin`. */
export function useCanManageOrg(): boolean {
  const { activeOrganization } = useActiveOrganization();
  return (
    activeOrganization?.role === MemberRole.Owner || activeOrganization?.role === MemberRole.Admin
  );
}
